import { useSelector } from "react-redux";
import { FlightSearchSelectors } from "@b2bportal/core-flights";
import { PackageFlightDeparturePage as CorePackageFlightDeparturePage } from "@b2bportal/core-packages";
import type { PackageFlightDeparturePageProps } from "@b2bportal/core-packages";
import { PackageNoAvailabilityModal } from "@/pages/Packages/components";

export const PackageFlightDeparturePage = (
  props: PackageFlightDeparturePageProps
) => {
  const { context } = props;
  const { flightList, isLoading } = context;
  const numberOfFiltersApplied = useSelector(
    FlightSearchSelectors.getActiveFiltersCount
  );

  const shouldShowModal =
    !isLoading && flightList?.length === 0 && numberOfFiltersApplied === 0;

  return (
    <>
      <CorePackageFlightDeparturePage {...props} />
      <PackageNoAvailabilityModal shouldShow={shouldShowModal} />
    </>
  );
};
